export default {
    cancelOrderMap: {
        '1': 'Λάθος προϊόν παραγγέλθηκε',
        '2': 'Διπλή παραγγελία',
        '3': 'Δεν είναι δυνατή η παραλαβή',
        '4': 'Άλλοι λόγοι',
    },
    '1': 'Λάθος προϊόν παραγγέλθηκε',
    '2': 'Διπλή παραγγελία',
    '3': 'Δεν είναι δυνατή η παραλαβή',
    '4': 'Άλλοι λόγοι',
    '-连接已建立-': '-Η σύνδεση δημιουργήθηκε-',
    ',才可提币': ', για να γίνει ανάληψη',
    '[code]值错误': 'Λανθασμένη τιμή [code]',
    '[symbol]参数为空': 'Η παράμετρος [symbol] είναι κενή',
    homeDownloadtips41: 'Εφαρμογή εμπόρου',
    '不能为空': 'Δεν μπορεί να είναι κενό',
    '不在交易时段': 'Εκτός ωρών συναλλαγών',
    '不在可提现时间内': 'Εκτός ωρών ανάληψης',
    '参数错误': 'Σφάλμα παραμέτρου',
    '参数异常，消息获取失败': 'Ανωμαλία παραμέτρου, αποτυχία λήψης μηνύματος',
    '操作成功': 'Επιτυχής λειτουργία',
    '操作类型不能小于0': 'Ο τύπος λειτουργίας δεν μπορεί να είναι μικρότερος από 0',
    '操作类型不是整数': 'Ο τύπος λειτουργίας δεν είναι ακέραιος',
    '操作类型为空': 'Ο τύπος λειτουργίας είναι κενός',
    '产品不存在': 'Το προϊόν δεν υπάρχει',
    '产品剩余数量不足': 'Ανεπαρκής υπολειπόμενη ποσότητα προϊόντος',
    '承兑商不存在': 'Ο έμπορος δεν υπάρχει',
    '程序错误': 'Σφάλμα προγράμματος',
    '持有币种不足': 'Ανεπαρκές υπόλοιπο νομίσματος',
    '充值价值不得大于最大限额': 'Η αξία φόρτισης δεν μπορεί να υπερβαίνει το μέγιστο όριο',
    '充值价值不得小于最小限额': 'Η αξία φόρτισης δεν μπορεί να είναι μικρότερη από το ελάχιστο όριο',
    '充值链错误': 'Σφάλμα αλυσίδας φόρτισης',
    '充值数量不能小于等于0': 'Η ποσότητα φόρτισης δεν μπορεί να είναι μικρότερη ή ίση με 0',
    '存在不同杠杆的持仓单': 'Υπάρχουν θέσεις με διαφορετική μόχλευση',
    '存在重复的角色名称': 'Υπάρχει διπλό όνομα ρόλου',
    '大于最大采购数量': 'Μεγαλύτερο από τη μέγιστη ποσότητα αγοράς',
    '代理层级错误': 'Σφάλμα επιπέδου αντιπροσώπου',
    '待付款的订单无法放行': 'Μια παραγγελία σε εκκρεμότητα πληρωμής δεν μπορεί να αποδεσμευτεί',
    '当前地址格式错误': 'Λανθασμένη μορφή τρέχουσας διεύθυνσης',
    '当前订单不为待付款状态，无法取消': 'Η παραγγελία δεν είναι σε κατάσταση αναμονής πληρωμής, δεν μπορεί να ακυρωθεί',
    '当前还需交易': 'Απαιτούνται ακόμη περαιτέρω συναλλαγές',
    '当日才可申购': 'Η εγγραφή είναι δυνατή μόνο την ίδια ημέρα',
    '当日可提现次数不足': 'Ανεπαρκής αριθμός αναλήψεων για σήμερα',
    '登陆密码不符合设定': 'Ο κωδικός σύνδεσης δεν πληροί τις απαιτήσεις',
    '登陆密码长度不符合设定': 'Το μήκος του κωδικού σύνδεσης δεν πληροί τις απαιτήσεις',
    '登录过期，请重新登录': 'Η συνεδρία έληξε, συνδεθείτε ξανά',
    '登录密码必须6-12位': 'Ο κωδικός σύνδεσης πρέπει να έχει 6-12 χαρακτήρες',
    '登录密码不能为空': 'Ο κωδικός σύνδεσης δεν μπορεί να είναι κενός',
    '登录失败': 'Αποτυχία σύνδεσης',
    '电话号码已绑定': 'Ο αριθμός τηλεφώνου είναι ήδη συνδεδεμένος',
    '电话号码已绑定其他用户': 'Ο αριθμός τηλεφώνου είναι ήδη συνδεδεμένος με άλλον χρήστη',
    '订单不存在': 'Η παραγγελία δεν υπάρχει',
    '订单已取消': 'Η παραγγελία ακυρώθηκε',
    '订单已取消，无法放行': 'Η παραγγελία ακυρώθηκε, δεν μπορεί να αποδεσμευτεί',
    '订单已完成，无法放行': 'Η παραγγελία ολοκληρώθηκε, δεν μπορεί να αποδεσμευτεί',
    '发现新版本，请升级到最新版本': 'Βρέθηκε νέα έκδοση, ενημερώστε στην τελευταία έκδοση',
    '服务器错误': 'Σφάλμα διακομιστή',
    '服务器错误(500)': 'Σφάλμα διακομιστή (500)',
    '该产品未上架': 'Αυτό το προϊόν δεν έχει καταχωριστεί',
    '该产品已上市，无法购买': 'Αυτό το προϊόν έχει ήδη καταχωριστεί, δεν μπορεί να αγοραστεί',
    '该订单已取消': 'Αυτή η παραγγελία ακυρώθηκε',
    '该广告剩余数量不足': 'Ανεπαρκής υπολειπόμενη ποσότητα αυτής της διαφήμισης',
    '该基金尚未开放购买': 'Αυτό το ταμείο δεν είναι ακόμη ανοιχτό για αγορά',
    '该基金尚已封闭': 'Αυτό το ταμείο έχει ήδη κλείσει',
    '该邮箱已被订阅': 'Αυτό το email είναι ήδη εγγεγραμμένο',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Σφάλμα μορφής: το ποσό φόρτισης δεν μπορεί να είναι μικρότερο από 1 (δύο δεκαδικά)',
    '跟单倍数输入错误': 'Λανθασμένη εισαγωγή πολλαπλασιαστή copy trading',
    '跟单参数输入错误': 'Λανθασμένη εισαγωγή παραμέτρων copy trading',
    '更新提醒': 'Υπενθύμιση ενημέρωσης',
    '工作地址不能为空': 'Η διεύθυνση εργασίας δεν μπορεί να είναι κενή',
    '购买矿机时间不得低于托管订单剩余时间': 'Η διάρκεια αγοράς του εξορύκτη δεν μπορεί να είναι μικρότερη από τον υπολειπόμενο χρόνο της παραγγελίας φιλοξενίας',
    '广告不存在': 'Η διαφήμιση δεν υπάρχει',
    '广告已下架': 'Η διαφήμιση αφαιρέθηκε',
    '基金剩余购买金额不足': 'Ανεπαρκές υπολειπόμενο ποσό αγοράς ταμείου',
    '家庭地址不能为空': 'Η διεύθυνση κατοικίας δεν μπορεί να είναι κενή',
    '交易员不存在': 'Ο trader δεν υπάρχει',
    '交易员不能跟随自己': 'Ο trader δεν μπορεί να ακολουθήσει τον εαυτό του',
    '交易员跟随人数已满': 'Ο αριθμός ακολούθων του trader είναι πλήρης',
    '交易员未开启带单': 'Ο trader δεν έχει ενεργοποιήσει το copy trading',
    '交易员无法跟随另一个交易员': 'Ένας trader δεν μπορεί να ακολουθήσει άλλον trader',
    '角色被用户关联，不可删除': 'Ο ρόλος είναι συνδεδεμένος με χρήστες, δεν μπορεί να διαγραφεί',
    '角色不存在': 'Ο ρόλος δεν υπάρχει',
    '金额不在购买区间': 'Το ποσό δεν είναι στο εύρος αγοράς',
    '金额错误': 'Σφάλμα ποσού',
    '旧密码不能为空': 'Ο παλιός κωδικός δεν μπορεί να είναι κενός',
    '旧密码不正确': 'Ο παλιός κωδικός είναι λανθασμένος',
    '可平仓合约张数不足': 'Ανεπαρκής αριθμός συμβολαίων προς κλείσιμο',
    '矿机不存在': 'Ο εξορύκτης δεν υπάρχει',
    '矿机未解锁，无法购买': 'Ο εξορύκτης δεν είναι ξεκλείδωτος, δεν μπορεί να αγοραστεί',
    '历史基金无法购买': 'Τα ιστορικά ταμεία δεν μπορούν να αγοραστούν',
    '连续输入错误三次，请3分钟后再试': 'Τρεις λανθασμένες εισαγωγές στη σειρά, δοκιμάστε ξανά σε 3 λεπτά',
    '领取成功': 'Επιτυχής παραλαβή',
    '买入金额需要在区间内': 'Το ποσό αγοράς πρέπει να είναι εντός του εύρους',
    '卖方无法取消该订单': 'Ο πωλητής δεν μπορεί να ακυρώσει αυτήν την παραγγελία',
    '没有找到用户': 'Δεν βρέθηκε χρήστης',
    verificationCode: 'Κωδικός επαλήθευσης',
    pleaseEnterVerificationCode: 'Εισαγάγετε τον κωδικό επαλήθευσης',
    pleaseEnterUsername: 'Εισαγάγετε το όνομα χρήστη',
    username: 'Όνομα χρήστη',
    getVerificationCode: 'Λήψη κωδικού',
    tryAgainLater: 'δευτερόλεπτα για επανάληψη',
    '密码必须6-12位': 'Ο κωδικός πρέπει να έχει 6-12 χαρακτήρες',
    '密码不能为空': 'Ο κωδικός δεν μπορεί να είναι κενός',
    '密码不正确': 'Ο κωδικός είναι λανθασμένος',
    '您当前可分配额度不足': 'Το τρέχον εκχωρήσιμο όριό σας είναι ανεπαρκές',
    '您没有符合条件的收款方式': 'Δεν έχετε κατάλληλη μέθοδο είσπραξης',
    '您已存在订单': 'Έχετε ήδη μια παραγγελία',
    '您已购买过体验矿机,不得重复购买': 'Έχετε ήδη αγοράσει δοκιμαστικό εξορύκτη, δεν μπορείτε να αγοράσετε ξανά',
    '亲属地址不能为空': 'Η διεύθυνση συγγενή δεν μπορεί να είναι κενή',
    '亲属电话不能为空': 'Το τηλέφωνο συγγενή δεν μπορεί να είναι κενό',
    '亲属关系不能为空': 'Η συγγενική σχέση δεν μπορεί να είναι κενή',
    '亲属姓名不能为空': 'Το όνομα συγγενή δεν μπορεί να είναι κενό',
    '请检查网络连接': 'Ελέγξτε τη σύνδεση δικτύου',
    '请上传图片': 'Ανεβάστε μια εικόνα',
    '请稍后再试': 'Δοκιμάστε ξανά αργότερα',
    '请稍后重试': 'Δοκιμάστε ξανά αργότερα',
    '请输入充值币种': 'Εισαγάγετε το νόμισμα φόρτισης',
    '请输入内容': 'Εισαγάγετε περιεχόμενο',
    '请输入搜索关键字': 'Εισαγάγετε λέξη-κλειδί αναζήτησης',
    '请输入正确的货币数量': 'Εισαγάγετε σωστή ποσότητα νομίσματος',
    '请输入正确的金额': 'Εισαγάγετε σωστό ποσό',
    '请输入正确的数量': 'Εισαγάγετε σωστή ποσότητα',
    '请输入正确的质押金额': 'Εισαγάγετε σωστό ποσό staking',
    '请输入正确的质押天数': 'Εισαγάγετε σωστό αριθμό ημερών staking',
    '请填写正确的电话号码': 'Εισαγάγετε σωστό αριθμό τηλεφώνου',
    '请填写正确的验证码': 'Εισαγάγετε σωστό κωδικό επαλήθευσης',
    '请填写正确的邮箱地址': 'Εισαγάγετε σωστή διεύθυνση email',
    '请先绑定谷歌验证器': 'Συνδέστε πρώτα το Google Authenticator',
    '请先添加收款方式': 'Προσθέστε πρώτα μια μέθοδο είσπραξης',
    '请先通过高级认证': 'Ολοκληρώστε πρώτα την προηγμένη επαλήθευση',
    '请选择买卖方式': 'Επιλέξτε μέθοδο αγοράς/πώλησης',
    '请选择正确的币种': 'Επιλέξτε το σωστό νόμισμα',
    '请重新登录': 'Συνδεθείτε ξανά',
    '渠道未开通': 'Το κανάλι δεν έχει ενεργοποιηθεί',
    '取消': 'Ακύρωση',
    '确认': 'Επιβεβαίωση',
    '申购数量错误': 'Λανθασμένη ποσότητα εγγραφής',
    '申请成功': 'Επιτυχής αίτηση',
    '身份证已实名过!': 'Η ταυτότητα έχει ήδη επαληθευτεί!',
    '审核已通过': 'Ο έλεγχος εγκρίθηκε',
    '审核中': 'Σε έλεγχο',
    '实名认证未通过，无法进行高级认证': 'Η επαλήθευση ταυτότητας δεν πέρασε, δεν είναι δυνατή η προηγμένη επαλήθευση',
    '收款方输入错误': 'Λανθασμένη εισαγωγή δικαιούχου',
    '授权状态未成功': 'Η κατάσταση εξουσιοδότησης δεν ήταν επιτυχής',
    '赎回状态异常': 'Μη φυσιολογική κατάσταση εξαγοράς',
    '所选汇率不存在': 'Η επιλεγμένη ισοτιμία δεν υπάρχει',
    '提币数量不能小于等于0': 'Η ποσότητα ανάληψης δεν μπορεί να είναι μικρότερη ή ίση με 0',
    '提交失败，当前有未处理订单': 'Αποτυχία υποβολής, υπάρχουν ανεπεξέργαστες παραγγελίες',
    '提示': 'Ειδοποίηση',
    '提现不得大于限额': 'Η ανάληψη δεν μπορεί να υπερβαίνει το όριο',
    '提现不得小于限额': 'Η ανάληψη δεν μπορεί να είναι μικρότερη από το όριο',
    '图片不得大于10M': 'Η εικόνα δεν μπορεί να υπερβαίνει τα 10 MB',
    '图片不得大于2M': 'Η εικόνα δεν μπορεί να υπερβαίνει τα 2 MB',
    '图片大小不能超过2M！': 'Το μέγεθος της εικόνας δεν μπορεί να υπερβαίνει τα 2 MB!',
    '图片上传失败': 'Αποτυχία μεταφόρτωσης εικόνας',
    '推荐码不正确': 'Ο κωδικός παραπομπής είναι λανθασμένος',
    '推荐人无权限推荐': 'Ο παραπέμπων δεν έχει δικαίωμα παραπομπής',
    '委托数量(张)必填': 'Η ποσότητα εντολής (συμβόλαια) είναι υποχρεωτική',
    '委托数量(张)不能小于等于0': 'Η ποσότητα εντολής (συμβόλαια) δεν μπορεί να είναι μικρότερη ή ίση με 0',
    '未绑定谷歌验证器': 'Το Google Authenticator δεν έχει συνδεθεί',
    '未绑定手机号': 'Δεν έχει συνδεθεί αριθμός τηλεφώνου',
    '未绑定邮箱': 'Δεν έχει συνδεθεί email',
    '未发现授权记录': 'Δεν βρέθηκε εγγραφή εξουσιοδότησης',
    '未实名认证，是否认证？': 'Δεν έχει επαληθευτεί. Επαλήθευση τώρα;',
    '未授权访问': 'Μη εξουσιοδοτημένη πρόσβαση',
    '未找到符合条件的匹配订单': 'Δεν βρέθηκε αντίστοιχη παραγγελία',
    '未找到匹配的收益记录': 'Δεν βρέθηκε αντίστοιχη εγγραφή εσόδων',
    myComment: 'Οι κριτικές μου',
    myPoint: 'Οι πόντοι μου',
    accountInfo: 'Πληροφορίες λογαριασμού',
    myBalance: 'Το υπόλοιπό μου',
    myCoupon: 'Τα κουπόνια μου',
    unused: 'Αχρησιμοποίητο',
    used: 'Χρησιμοποιημένο',
    expired: 'Έληξε',
    expires: 'Ισχύει έως',
    minSpend: 'Από',
    availableBalance: 'Διαθέσιμο υπόλοιπο',
    personalDeposit: 'Υπόλοιπο',
    useDepositBalance: 'Χρήση υπολοίπου για έκπτωση',
    depositDeduct: 'Αφαίρεση υπολοίπου',
    useMaxDeposit: 'Πλήρης αφαίρεση',
    balanceHistory: 'Ιστορικό υπολοίπου',
    recordCount: 'Σύνολο {count} εγγραφές',
    depositType: 'Τύπος συναλλαγής',
    balanceAfter: 'Υπόλοιπο',
    depositTypeRecharge: 'Φόρτιση υπολοίπου',
    depositTypeAdjustment: 'Προσαρμογή υπολοίπου',
    depositTypeOrderPayment: 'Πληρωμή παραγγελίας',
    depositTypeOrderRefunds: 'Επιστροφή παραγγελίας',
    depositTypeDistributionCommission: 'Προμήθεια διανομής',
    depositTypeDistributionWithdrawal: 'Ανάληψη διανομής',
    depositTypeOther: 'Άλλο',
    income: 'Έσοδα',
    expense: 'Έξοδα',
    description: 'Περιγραφή',
    myFootprint: 'Το ιστορικό μου',
    '无权限': 'Χωρίς δικαίωμα',
    '无效的UID': 'Μη έγκυρο UID',
    '系统参数错误': 'Σφάλμα παραμέτρου συστήματος',
    '系统存在相同[系统登录名]！': 'Το σύστημα έχει ήδη το ίδιο [όνομα σύνδεσης]!',
    '系统错误，请稍后重试': 'Σφάλμα συστήματος, δοκιμάστε ξανά αργότερα',
    '下单不能小于最小金额限制': 'Η παραγγελία δεν μπορεί να είναι μικρότερη από το ελάχιστο ποσό',
    '校验IP不合法': 'Μη έγκυρη IP επαλήθευσης',
    '新密码不能为空': 'Ο νέος κωδικός δεν μπορεί να είναι κενός',
    '新密码不一致': 'Οι νέοι κωδικοί δεν ταιριάζουν',
    '新密码确认不能为空': 'Η επιβεβαίωση νέου κωδικού δεν μπορεί να είναι κενή',
    '行情获取异常，稍后再试': 'Αποτυχία λήψης δεδομένων αγοράς, δοκιμάστε ξανά αργότερα',
    '验证类型不能为空': 'Ο τύπος επαλήθευσης δεν μπορεί να είναι κενός',
    '验证码不能为空': 'Ο κωδικός επαλήθευσης δεν μπορεί να είναι κενός',
    '验证码不正确': 'Ο κωδικός επαλήθευσης είναι λανθασμένος',
    '验证码错误': 'Σφάλμα κωδικού επαλήθευσης',
    '页码不能小于等于0': 'Ο αριθμός σελίδας δεν μπορεί να είναι μικρότερος ή ίσος με 0',
    '页码不是整数': 'Ο αριθμός σελίδας δεν είναι ακέραιος',
    '已领取': 'Ήδη παραληφθέν',
    '用户不存在': 'Ο χρήστης δεν υπάρχει',
    '用户名必须由数字和英文字母组成': 'Το όνομα χρήστη πρέπει να αποτελείται από αριθμούς και λατινικά γράμματα',
    '用户名不存在': 'Το όνομα χρήστη δεν υπάρχει',
    '用户名不符合设定': 'Το όνομα χρήστη δεν πληροί τις απαιτήσεις',
    '用户名不能为空': 'Το όνομα χρήστη δεν μπορεί να είναι κενό',
    '用户名参数为空': 'Η παράμετρος ονόματος χρήστη είναι κενή',
    '用户名重复': 'Διπλό όνομα χρήστη',
    '用户剩余数量不足': 'Ανεπαρκής υπολειπόμενη ποσότητα χρηστών',
    '用户已跟随交易员': 'Ο χρήστης ακολουθεί ήδη τον trader',
    '邮箱已绑定': 'Το email είναι ήδη συνδεδεμένο',
    '邮箱已绑定其他用户': 'Το email είναι ήδη συνδεδεμένο με άλλον χρήστη',
    '余额不足': 'Ανεπαρκές υπόλοιπο',
    shop_order_insufficientBalance: 'Ανεπαρκές υπόλοιπο λογαριασμού',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Ανωμαλία λογαριασμού, απαιτείται επαλήθευση C3. Επικοινωνήστε με την ηλεκτρονική εξυπηρέτηση πελατών.',
    '找不到用户': 'Ο χρήστης δεν βρέθηκε',
    flashSale: 'Flash Sale',
    groupBuy: 'Ομαδική αγορά',
    groupBuying: 'Ομαδική αγορά',
    couponCenter: 'Κέντρο κουπονιών',
    pointMall: 'Κατάστημα πόντων',
    liveList: 'Ζωντανή μετάδοση',
    endsIn: 'Λήγει σε',
    soldOut: 'Πουλήθηκε',
    people: 'άτομα',
    joined: 'Συμμετείχαν',
    startGroup: 'Έναρξη ομαδικής αγοράς',
    getCoupon: 'Λήψη',
    '直线关系，不能修改推荐': 'Άμεση σχέση, η παραπομπή δεν μπορεί να τροποποιηθεί',
    '重复提交': 'Διπλή υποβολή',
    '转账币种不能为空': 'Το νόμισμα μεταφοράς δεν μπορεί να είναι κενό',
    '转账数量不能小于等于0': 'Η ποσότητα μεταφοράς δεν μπορεί να είναι μικρότερη ή ίση με 0',
    '状态不能小于0': 'Η κατάσταση δεν μπορεί να είναι μικρότερη από 0',
    '状态不是整数': 'Η κατάσταση δεν είναι ακέραιος',
    '资金密码必须6-12位': 'Ο κωδικός κεφαλαίων πρέπει να έχει 6-12 χαρακτήρες',
    '资金密码不符合设定': 'Ο κωδικός κεφαλαίων δεν πληροί τις απαιτήσεις',
    '资金密码不能为空': 'Ο κωδικός κεφαλαίων δεν μπορεί να είναι κενός',
    '资金密码错误': 'Σφάλμα κωδικού κεφαλαίων',
    '资金密码长度不符合设定': 'Το μήκος του κωδικού κεφαλαίων δεν πληροί τις απαιτήσεις',
    'UID不能为空': 'Το UID δεν μπορεί να είναι κενό',
    required: 'Αυτό το πεδίο είναι υποχρεωτικό',
    nickname: 'Ψευδώνυμο',
    enterNickname: 'Εισαγάγετε ψευδώνυμο',
    gender: 'Φύλο',
    male: 'Άνδρας',
    female: 'Γυναίκα',
    secret: 'Απόρρητο',
    birthday: 'Γενέθλια',
    selectDate: 'Επιλογή ημερομηνίας',
  "cancelorderMap": {
    0: "Δεν το θέλω.",
    1: "Τοποθέτησε λάθος το προϊόν",
    2: "Διπλότυπη παραγγελία",
    3: "Η λήψη απέτυχε",
    4: "Αλλοι λόγοι"
  },
  "获取验证码": "Λάβετε τον κωδικό",
  "请输入验证码": "Εισαγάγετε τον κωδικό",
  "验证码": "Κωδικός επιβεβαίωσης",
  "发送":"SEND",
  "已发送，请注意查收": "Αποστέλλοντας, ενημερώστε σας",
  "加值": "Προσθήκη",
  "备注": "Σημείωση",
  "当前余额": "Τρέχον υπόλοιπο",
  "银行卡": "Κάρτα τραπέζης",
  "联系商家": "Επικοινωνήστε με τον πωλητή",
  "提领": "Ανάκτηση",
  "平台人工发起退款": "Η πλατφόρμα εκκίνησε την επιστροφή χρημάτων",
  "电商批发商场": "Ηλεκτρονική αγορά χονδρικής πώλησης",
  "请输入完整的支付密码!" : "Εισαγάγετε τον πλήρη κωδικό πληρωμής!",
  "最多上传9张图片": "Μέγιστο 9 εικόνες",
  "账号注销": "Ακύρωση λογαριασμού",
  "确定注销": "Επιβεβαίωση ακύρωσης",
  "加密货币": "Κρυπτονόμισμα",
  "银行卡": "Κάρτα τραπέζης",
  '参数缺失': 'Λείπουν παράμετροι',
  '充值数量必填': 'Το ποσό επαναφόρτισης είναι υποχρεωτικό',
  "充值币种": "Νόμισμα επαναφόρτισης",
  "充值金额": "Ποσό επαναφόρτισης",
  "充值金额不得小于": "Το ποσό επαναφόρτισης δεν μπορεί να είναι μικρότερο από",
  "充值金额不得大于": "Το ποσό επαναφόρτισης δεν μπορεί να είναι μεγαλύτερο από",
  "请先选择币种": "Επιλέξτε πρώτα το νόμισμα",
  "开户行": "Τράπεζα",
  "请输入开户行名称": "Εισαγάγετε το όνομα της τράπεζας",
  "银行卡号": "Αριθμός κάρτας",
  "请输入银行卡号": "Εισαγάγετε τον αριθμό της κάρτας",
  "点击去支付": "Κάντε κλικ για πληρωμή",
  "企业证明": "Πιστοποιητικό επιχείρησης",
  "您的账号": "Ο λογαριασμός σας",
  "为什么要离开": "Γιατί να φύγετε",
  "您还有余额,不能注销账号": "Υπάρχει ακόμα υπόλοιπο στον λογαριασμό σας, δεν μπορείτε να ακυρώσετε τον λογαριασμό!",
  "请输入注销理由": "Εισαγάγετε τον λόγο ακύρωσης",
  "您确认要注销吗?": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε τον λογαριασμό σας;",
  "我再考虑下": "Θα σκεφτώ ξανά",
  "同意注销": "Συμφωνώ με την ακύρωση",
  "注销成功": "Επιτυχής ακύρωση",
  "cancelInfo":"προειδοποιώ! Προσέξτε να ακυρώσετε τον λογαριασμό. Εάν δεν χρησιμοποιείτε πλέον τον λογαριασμό, μπορείτε να κάνετε κλικ στο [Agree to Cancellation]. Ενδέχεται να μην μπορείτε να εγγραφείτε εντός λίγων ημερών μετά την ακύρωση.",
  "App下载(买家端)": "Λήψη App (Αγοραστής)",
  "App下载(卖家端)": "Λήψη App (Πωλητής)",
  recommendclass:"Προτείνετε κατηγορία",
  "滑动验证": "Επιβεβαίωση κύλισης",
  "用户未发表评论": "Ο χρήστης δεν έχει σχολιάσει",
  "订单": "Σειρά",
  "下单成功，等待付款": "Η παραγγελία ολοκληρώθηκε με επιτυχία, σε αναμονή για πληρωμή",
  "下单成功，付款成功": "Η παραγγελία πραγματοποιήθηκε με επιτυχία, η πληρωμή ολοκληρώθηκε",
  "已发货，正在运输中": "Αποστέλλεται, κατά τη μεταφορά",
  "订单已取消，原因:手动发起取消订单": "Η παραγγελία ακυρώθηκε. Αιτία: Ακύρωση της παραγγελίας με μη αυτόματο τρόπο.",
  "订单已取消，原因:超时自动取消订单": "Η παραγγελία ακυρώθηκε. Αιτία: Η παραγγελία θα ακυρωθεί αυτόματα μετά το χρονικό όριο.",
  "商家已确认，已进入备货状态": "Ο έμπορος έχει επιβεβαιωθεί και έχει εισέλθει στο απόθεμα.",
  "系统发货成功": "Η παράδοση του συστήματος πέτυχε",
  "长时间未付款，系统自动取消订单": "Η πληρωμή δεν έχει πραγματοποιηθεί για μεγάλο χρονικό διάστημα και η παραγγελία θα ακυρωθεί αυτόματα.",
  "订单已签收": "Εντολή Ελήφθη",
  "发起退款申请": "Ξεκινήστε ένα αίτημα επιστροφής χρημάτων",
  "退款成功": "Επιτυχής επιστροφή χρημάτων",
  "退款失败": "Η επιστροφή χρημάτων απέτυχε",
  "订单退款成功": "Επιτυχής επιστροφή χρημάτων παραγγελίας",
  "订单退款失败": "Η επιστροφή χρημάτων παραγγελίας απέτυχε",
  "系统默认好评": "Το σύστημα προεπιλογή για ευνοϊκές κριτικές",
  "请输入关键字搜索": "Εισαγάγετε λέξη-κλειδί για αναζήτηση",
  "mailboxCheck": "Συμπληρώστε τη σωστή διεύθυνση email",
  "猜你喜欢": "Μαντέψτε ότι σας αρέσει",
  "订单已完成": "Η παραγγελία ολοκληρώθηκε",
  "热销推荐": "Καυτή σύσταση πώλησης",
  "头像选择": "Επιλογή Avatar",
  "修改头像": "Τροποποιήστε το avatar σας",
  subOrder: "Υποβάλετε την παραγγελία",
  "switchLang": "Μεταβείτε σε άλλη γλώσσα για προβολή",
  "myCart": "Το καλάθι αγορών μου",
  "notQua": "Δεν πληρούνται οι προϋποθέσεις πρόκρισης.",
  "noSmaller": "Το ποσό που εφαρμόζεται δεν μπορεί να είναι μικρότερο από",
  "nomax": "Το μέγιστο ποσό αίτησης δεν μπορεί να υπερβαίνει",
  "evaluationUploading": "Έχετε ακόμα φωτογραφίες για μεταφόρτωση. Παρακαλώ δοκιμάστε ξανά αργότερα",
  "evaluateInput": "Κριτική με εικόνες",
  "moneyOrderStatus": "Κατάσταση παραγγελίας",
  "coinBlock": "Συναλλαγματική συμφωνία",
  "dealing": "Σε εξέλιξη",
  "dealSuccess": "Επιτυχής",
  "dealFail": "Αποτυγχάνω",
  "payCertificate": "Πιστοποιητικό πληρωμής",
  "handleFee": "Χρέωση υπηρεσίας",
  "highOpinion": "Καλές κριτικές",
  "mediumOpinion": "Μεσαία κριτική",
  "lowOpinion": "Κακές κριτικές",
  "hasImage": "Με εικόνες",
  "rechargeMethod": "Λειτουργία επαναφόρτισης",
  "scanAndDown": "Σάρωση κωδικού QR Λήψη APP",
  "receivedAddress": "Διεύθυνση απόδειξης",
  "ActualLedger": "Πραγματική απόδειξη",
  "view": "Θέα",
  "withdrawNum": "Ποσότητα ανάληψης μετρητών",
  "rechargeNum": "Ποσότητα επαναφόρτισης",
  "date": "Ημερομηνία",
  "walletHistory": "Ιστορικό πορτοφολιού",
  "accountBalance": "Υπόλοιπο λογαριασμού",
  "accountReview": "Σύνοψη λογαριασμού",
  "rated": "Αξιολογήθηκε",
  "receiver": "Δέκτης",
  "orderStatus": "Κατάσταση",
  "orderTime": "χρόνος",
  "tax": "Φορολογία",
  "discount": "Εκπτωση",
  "productInfo": "Πληροφορίες Προϊόντος",
  "paramError": "Σφάλμα παραμέτρου",
  "orderInfo": "Πληροφορίες Παραγγελίας",
  "rebuy": "Άλλη μια παραγγελία",
  "pleaseCorrectAddress": "Εισαγάγετε τη σωστή διεύθυνση ανάληψης μετρητών",
  "pleaseInputCorrectNumber": "Εισαγάγετε έναν αριθμό μεγαλύτερο από 0",
  "vcodePass": "Η επαλήθευση πέρασε!",
  "vcodeFail": "Η ταυτοποίηση απέτυχε. Παρακαλώ προσπάθησε ξανά",
  "uploading": "Μεταφόρτωση...",
  "uploadSuccess": "Η μεταφόρτωση ολοκληρώθηκε",
  "uploadError": "Η μεταφόρτωση απέτυχε. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα",
  "registerSuccess": "Η εγγραφή πέτυχε",
  "pleaseSetMobileNumber": "Ορίστε τον αριθμό τηλεφώνου",
  "unSelectedProduct": "Δεν έχετε επιλέξει προϊόν",
  "loginSuccess": "Η σύνδεση πέτυχε",
  "pleaseSetAreaCode": "Εισαγάγετε το όνομα της χώρας και τον κωδικό περιοχής για αναζήτηση",
  "login": "Σύνδεση",
  "register": "Εγγραφή",
  "logout": "Εξοδος",
  "noData": "Δε βρέθηκαν δεδομένα",
  "search": "Αναζήτηση",
  "historySearch": "Ιστορική αναζήτηση",
  "empty": "Αδειάζω",
  "home": "Αρχική σελίδα",
  "favorableRate": "Ποσοστό καλών κριτικών",
  "classification": "Κατηγορία",
  "searchTips": "Αναζήτηση πηγής/προϊόν/προμηθευτής/παραγγελία",
  "dailyNewArrival": "Καθημερινά παρατίθενται νέα προϊόντα",
  "more": "Περισσότερο",
  "recommend": "Σύσταση",
  "recommendedProducts": "Προτεινόμενα προϊόντα",
  "recommendedStore": "Προτεινόμενα καταστήματα",
  "buyNow": "Αγορά τώρα",
  "addCart": "Προσθήκη στο καλάθι αγορών",
  "complex": "Ολοκληρωμένο",
  "price": "Τιμή",
  "retailPrice": "Τιμή λιανικής",
  "originPrice": "Αρχική τιμή",
  "service": "Εξυπηρέτηση πελατών",
  "collect": "Αγαπημένα",
  "sold": "Ογκος ΠΩΛΗΣΕΩΝ",
  "pageviews": "Ποσότητα περιήγησης",
  "quantity": "Ποσότητα",
  "freight": "Φορτίο",
  "shipping": "Αποστολή",
  "ship": "Σκάφος",
  "buyTips": "Αποστολή εντός 24 ωρών από την υποβολή της παραγγελίας. Οι παρακάτω παραγγελίες είναι υπό έλεγχο logistics και ενδέχεται να αποσταλούν καθυστερημένα. Παρακαλούμε δώστε προσοχή στις πληροφορίες logistics ή επικοινωνήστε με την εξυπηρέτηση πελατών.",
  "totalPrice": "Συνολικό ποσό",
  "addCartMessage": "Προστέθηκε με επιτυχία στο καλάθι αγορών",
  "addCartMessageFaild": "Το προϊόν υπάρχει ήδη στο καλάθι αγορών.",
  "myAccount": "Ο λογαριασμός μου q",
  "buyHistory": "Εγγραφές αγορών",
  "wishlist": "Αγαπημένα προϊόντα",
  "trackOrder": "Σειρά",
  "account": "Λογαριασμός:",
  "sellerZone": "Εμπορική περιοχή",
  "beSeller": "Γίνε έμπορος",
  "sellerPanelLogin": "Είσοδος εμπόρου",
  "footTip": "© Πνευματικά δικαιώματα {name} Ltd 2024",
  "footTips": "Η {name} Limited είναι εξουσιοδοτημένη και ελέγχεται από την Αρχή Χρηματοοικονομικής Συμπεριφοράς ως μεσίτης πιστώσεων (713206) και συναλλάσσεται αποκλειστικά με τον δανειστή Home Retail Group CardServices Limited ως {name} Financial Services. Η {name} Financial Services είναι εξουσιοδοτημένη και ελέγχεται από την Αρχή Χρηματοοικονομικής Συμπεριφοράς για την παροχή πίστωσης (716148). Η Home Retail GroupCard Services Limited είναι εγγεγραμμένη στο Ηνωμένο Βασίλειο (04007072) στο Avebury, 489-499 Avebury Boulevard, Milton Keynes, Ηνωμένο Βασίλειο. ΜΚ9 2ΒΔ.",
  "item": "Αρθρο",
  "checkout": "Κάνετε μια παραγγελία",
  "productDescription": "περιγραφή προϊόντος",
  "userEvaluation": "Κριτικές χρηστών",
  "AllProducts": "Ολα τα προϊόντα",
  "followers": "Ακολουθηστε",
  "sales": "Ογκος ΠΩΛΗΣΕΩΝ",
  "visitStore": "Επισκεφθείτε το κατάστημα",
  "authentic": "100% Γνήσιο",
  "dayReturns7": "7 ημέρες επιστροφή",
  "shippingDiscounts": "Έκπτωση φορτίου",
  "safePayment": "Ασφαλής πληρωμή",
  "followed": "Ακολούθησαν",
  "dashboard": "Πίνακας οργάνων",
  "myOrder": "Η παραγγελία μου",
  "setUp": "Ρύθμιση",
  "successTips": "Επιτυχής",
  "copySuccess": "Η αναπαραγωγή πέτυχε",
  "balance": "Υπόλοιπο (USDT)",
  "sort": "Τύπος",
  "commodity": "Προϊόν",
  "browse": "Ογκος ΠΩΛΗΣΕΩΝ",
  "recharge": "Επαναφόρτιση",
  "commodityCollection": "Συλλογή προϊόντων",
  "withdraw": "ΑΝΑΛΗΨΗ ΜΕΤΡΗΤΩΝ",
  "defaultAddress": "Προεπιλεγμένη διεύθυνση",
  "addNewAddress": "Προσθήκη νέας διεύθυνσης",
  "withdrawRecord": "Ρεκόρ ανάληψης μετρητών",
  "serialNumber": "Αριθμός παραγγελίας.",
  "time": "χρόνος",
  "amount": "Ποσό",
  "processing": "Σε εξέλιξη",
  "fail": "Αποτυγχάνω",
  "blockchainNetwork": "Δίκτυο Blockchain",
  "records": "Ρεκόρ",
  "withdrawAddress": "Διεύθυνση ανάληψης μετρητών",
  "withdrawInputTips": "Εισαγάγετε τη διεύθυνση ανάληψης",
  "copy": "Αντιγραφή",
  "enterTips": "Παρακαλώ περάστε",
  "actualAccount": "Πραγματικός λογαριασμός",
  "handlingFee": "Χρέωση υπηρεσίας",
  "confirm": "Επιβεβαιώστε την παραλαβή",
  "previous": "Προηγούμενο βήμα",
  "pleaseEnterAddress": "Εισαγάγετε τη διεύθυνση",
  "pleaseEnterQuantity": "Παρακαλώ εισάγετε την ποσότητα",
  "withdrawSuccess": "Οι παραγγελίες υποβλήθηκαν με επιτυχία",
  "saveQr": "Αποθήκευση κωδικού QR",
  "pleaseEnterAmount": "Εισαγάγετε το ποσό επαναφόρτισης",
  "expectedArrival": "Αναμενόμενη άφιξη",
  "currentRate": "Τρέχουσα ισοτιμία",
  "uploadTips": "Απόδειξη πληρωμής (Μεταφόρτωση στιγμιότυπου οθόνης των λεπτομερειών πληρωμής)",
  "clickUpload": "Κάντε κλικ για μεταφόρτωση",
  "uploadPhoto": "Παρακαλώ ανεβάστε φωτογραφίες",
  "rechargeSuccessful": "Η επαναφόρτιση πέτυχε",
  "rechargeTips": "\"Προτροπή επαναφόρτισης: \"\"Συμπληρώστε με ειλικρίνεια το πραγματικό ποσό μεταφοράς. Διαφορετικά, το σύστημα ενδέχεται να μην περάσει την έγκριση και να επηρεάσει την πρόοδο της επαναφόρτισης.\"",
  "rechargeRecord": "Ρεκόρ επαναφόρτισης",
  "all": "Ολα",
  "pending": "Να πληρωθεί",
  "cancelled": "Ακυρώθηκε",
  "delivered": "Να αποσταλεί",
  "confirmed": "Επιβεβαιωμένος",
  "receipt": "Να παραληφθεί",
  "harvested": "Ελήφθη",
  "comment": "Προς επανεξέταση",
  "refund": "Επιστροφή χρημάτων/μετά την πώληση",
  "cancelOrder": "Ακύρωση παραγγελίας",
  "cancelReason": "Λόγος ακύρωσης",
  "cancelOrderTitle": "Επιλέξτε έναν λόγο ακύρωσης παραγγελίας",
  "returnOrderTitle": "Επιλέξτε τον λόγο επιστροφής",
  "refundInstructions": "Οδηγίες επιστροφής χρημάτων",
  "returnDetailTips": "Δώστε μια κριτική για το προϊόν",
  "cancel": "Ακύρωση παραγγελίας",
  "cancelOrder1": "Το προϊόν δεν παραλήφθηκε",
  "cancelOrder2": "Δεν μου αρέσει, δεν το θέλω",
  "cancelOrder3": "Ο πωλητής έστειλε λάθος προϊόντα",
  "cancelOrder4": "Ψεύτικη μάρκα",
  "cancelOrder5": "Λιγότερη αποστολή, χαμένη αποστολή",
  "cancelOrder6": "Το προϊόν ελήφθη κατεστραμμένο",
  "cancelOrder7": "Υπάρχει πρόβλημα ποιότητας",
  "cancelOrder8": "Διαπραγματευτείτε την επιστροφή χρημάτων με τον έμπορο",
  "cancelOrder9": "Αλλοι λόγοι",
  "cancelOrderSuccess": "Η παραγγελία ακυρώθηκε με επιτυχία",
  "returnOrderSuccess": "Υποβολή με επιτυχία",
  "orderName": "Ονομα",
  "orderEmail": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
  "orderAddress": "Διεύθυνση",
  "orderNation": "Χώρα",
  "orderState": "Κατάσταση",
  "orderCity": "Πόλη",
  "orderPostCode": "Ταχυδρομικός Κώδικας",
  "orderAmount": "Ποσότητα",
  "orderPrefix": "Συνολική παραγγελία",
  "orderFee": "Φόροι",
  "orderSpecification": "Προσδιορισμός",
  "orderCommodity": "Προϊόν",
  "orderQuantity": "Ποσότητα",
  "orderUnitprice": "Τιμή μονάδας",
  "orderFreight": "Φορτίο",
  "orderTax": "Φόρος",
  "orderTotal": "Σύνολο",
  "PaymentOrder": "Σειρά ΠΛΗΡΩΜΗΣ",
  "Evaluate": "Ανασκόπηση",
  "CancelOrder": "Ακύρωση παραγγελίας",
  "RemindShip": "Υπενθύμιση για αποστολή",
  "Refund": "Επιστροφή χρημάτων",
  "Submitareview": "Υποβάλετε κριτικές",
  "Information": "Πληροφορίες",
  "wrongPassword": "Σφάλμα κωδικού πρόσβασης περισσότερες από 3 φορές. Δοκιμάστε ξανά αύριο.",
  "Operate": "Λειτουργία",
  "Item": "Αντικείμενο (α)",
  "From": "Από",
  "hint": "Συμβουλές",
  "CheckDetails": "Δείτε λεπτομέρειες",
  "Payment": "Πληρωμή",
  "Cancel": "Ματαίωση",
  "refundSuccessfully": "Επιτυχής επιστροφή χρημάτων",
  "pendingPayment": "Να πληρωθεί",
  "pay": "Πληρωμή",
  "LoginPassword": "Κωδικός σύνδεσης",
  "sure": "Φυσικά",
  "shippingAddress": "Διεύθυνση παραλαβής",
  "transactionPassword": "Κωδικός συναλλαγής",
  "markDefaultAddress": "Επισήμανση ως προεπιλεγμένη διεύθυνση αποστολής",
  "edit": "Επεξεργάστηκε από",
  "delete": "Διαγράφω",
  "Opt": "Επιλέγω",
  "piece": "τεμ",
  "orderDetails": "Λεπτομέρειες Παραγγελίας",
  "shopCollection": "Προσθέστε το κατάστημα στα αγαπημένα",
  "addAddress": "Προσθήκη νέας διεύθυνσης",
  "signUp": "Εγγραφή",
  "loginTips": "Έχετε ήδη λογαριασμό?",
  "loginIn": "Σύνδεση",
  "mobile": "Τηλέφωνο Αρ",
  '购物车还没有商品': 'Το καλάθι αγορών δεν έχει ακόμη προϊόντα',
  '去购物': 'Πήγαινε για ψώνια',
  "modifyAddress": "Τροποποίηση διεύθυνσης",
  "desc": "Ορισμός ως προεπιλεγμένη διεύθυνση",
  "keep": "Διατηρούν",
  "onlineService": "Διαδικτυακές υπηρεσίες",
  "send": "Στείλετε",
  "EsShop": "Ηλεκτρονικό κατάστημα",
  "desc3": "Εισαγάγετε τον κωδικό συναλλαγής",
  "desc4": "Εισαγάγετε τον κωδικό συναλλαγής σας",
  "desc6": "Εισαγάγετε ξανά τον κωδικό συναλλαγής σας",
  "setUpPayPaw": "Ορισμός κωδικού πρόσβασης συναλλαγής",
  "setSuccess": "Η εγκατάσταση πέτυχε",
  "confirmPayPaw": "Επιβεβαίωση κωδικού πρόσβασης συναλλαγής",
  "paymentSuccessful": "Η πληρωμή ολοκληρώθηκε",
  "desc5": "Λάθος διεύθυνση αποστολής; Επικοινωνία",
  "customeService": "Ηλεκτρονική εξυπηρέτηση πελατών",
  "BackHome": "Επιστροφή στην αρχική σελίδα",
  "Checkorder": "Προβολή παραγγελίας",
  "ForgotPassword": "Ξεχάσατε τον κωδικό πρόσβασης;",
  "signIn": "Σύνδεση",
  "noAccount": "Δεν υπάρχει αριθμός λογαριασμού;",
  "pleaseEnterAccount": "Εισαγάγετε τον αριθμό λογαριασμού",
  "pleaseEnterPassword": "Παρακαλούμε εισάγετε τον κωδικό πρόσβασης",
  "password": "Κωδικός πρόσβασης",
  "mobilePhone": "Τηλεφωνικό νούμερο",
  "pleaseEnterPhoneNumer": "Ορίστε τον αριθμό τηλεφώνου",
  "setPassword": "Ορίστε κωδικό",
  "noDataFound": "Δε βρέθηκαν δεδομένα",
  "searchCountry": "Εισαγάγετε το όνομα της χώρας και τον κωδικό περιοχής για αναζήτηση",
  "pleaseEnterEmail": "Ρυθμίστε το γραμματοκιβώτιο",
  "invitationCode": "Κωδικός πρόσκλησης",
  "plaeseEnterInvitaionCode": "Ορίστε τον κωδικό πρόσκλησης",
  "pleaseSetLoginPassword": "Ορίστε τον κωδικό πρόσβασης σύνδεσης",
  "selectDeliveryAddress": "Επιλέξτε διεύθυνση αποστολής",
  "totalOf": "Σύνολο",
  "items": "Είδος",
  "orderSummary": "Περίληψη παραγγελίας",
  "paymentMethod": "Μέθοδος πληρωμής",
  "Balance": "Ισορροπία",
  "payPal": "PayPal",
  "notOpen": "Αυτή η μέθοδος πληρωμής δεν είναι ακόμη ανοιχτή στην περιοχή σας",
  "mastercard": "MasterCard",
  "additional": "Επιπλέον",
  "handlingfee": "Απαιτείται χρέωση υπηρεσιών",
  "goodsNumber": "Ποσότητα προϊόντων",
  "deliveryFee": "Φορτίο",
  "totalNum": "Σύνολο",
  "new": "Νέος",
  "oldPassword": "ΠΑΛΙΟΣ ΚΩΔΙΚΟΣ",
  "pleaseEnterOldPassword": "Εισαγάγετε τον παλιό κωδικό πρόσβασης",
  "newPassword": "Νέος Κωδικός",
  "plaseeEnterNewPassword": "Εισαγάγετε τον νέο κωδικό πρόσβασης",
  "confirmPassword": "Επιβεβαίωση Κωδικού",
  "plaseeENterConfirmPassword": "Εισαγάγετε τον κωδικό επιβεβαίωσης",
  "twoPawword": "Δύο κωδικοί πρόσβασης δεν είναι ίδιοι",
  "rechargeAddress": "Διεύθυνση επαναφόρτισης",
  "plaseEnterRechargeAddress": "Εισαγάγετε τη διεύθυνση επαναφόρτισης",
  "userCenter": "Προσωπικό κέντρο",
  "merchantSettled": "Είσοδος εμπόρου",
  "upNew": "Αναφέρεται νέο προϊόν",
  "balanceNot": "Η ισορροπία δεν είναι αρκετή. Παρακαλώ επαναφορτίστε.",
  "NoProductSelected": "Το προϊόν δεν έχει επιλεγεί ακόμα",
  "ShippingAddressNotSet": "Η διεύθυνση αποστολής δεν έχει οριστεί",
  "consigneeName": "Όνομα παραλήπτη",
  "email": "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ:",
  "areaCode": "Διεθνής κωδικός περιοχής",
  "phoneNumber": "Τηλεφωνικό νούμερο",
  "nation": "Χώρα",
  "state": "Επαρχία/Πολιτεία/Πολιτεία",
  "city": "Πόλη",
  "postCode": "Ταχυδρομικός Κώδικας",
  "address": "Αναλυτική διεύθυνση",
  "addAddressOrModifyAddress": "Προσθήκη νέας διεύθυνσης/Τροποποίηση διεύθυνσης",
  "setAsTheDefaultAddress": "Ορισμός ως προεπιλεγμένη διεύθυνση",
  "proceed": "Να συνεχίσει",
  "btnSure": "Επιβεβαιώνω",
  "pleaseInput": "Παρακαλώ περάστε",
  "allProduct": "Ολα τα προϊόντα",
  "myCommodityCollection": "Αγαπημένα προϊόντα",
  "myFollowedShops": "Ακολουθήστε το κατάστημα",
  "mySold": "Πωληθεί",
  "myPageviews": "Ποσότητα περιήγησης",
  "myPraiseRate": "Ποσοστό καλών κριτικών",
  "myUnfollow": "Κατάργηση παρακολούθησης",
  "inputNum": "Αριθμοί",
  "inpuEmailErro": "Εισαγάγετε τη σωστή διεύθυνση email",
  "goodsShip": "Αποστολή",
  "goodsShipTips": "Τα προϊόντα θα αποσταλούν εντός 24 ωρών από την τοποθέτηση της παραγγελίας. Εάν υπάρχει έλεγχος logistics για την ακόλουθη παραγγελία, η παραγγελία μπορεί να καθυστερήσει. Παρακαλούμε δώστε προσοχή στις πληροφορίες logistics της παραγγελίας ή επικοινωνήστε με την εξυπηρέτηση πελατών.",
  "goodsFreight": "Φορτίο",
  "goodsFreeShipping": "Δωρεάν",
  "goodsFreightTips1": "1. Σύνθεση διασυνοριακού φορτίου προϊόντος: φορτίο=τέλη αποστολής+μεταφορά μεγάλων αποστάσεων+ τέλος παράδοσης",
  "goodsFreightTips2": "2. Εάν δεν πληρούνται οι όροι αποστολής, το ναύλο χρεώνεται σύμφωνα με τις πραγματικές συνθήκες.",
  "goodsFreightTips3": "3. Το δικαίωμα της τελικής ερμηνείας ανήκει στην πλατφόρμα.",
  "pleaseValidPostCode": "Εισαγάγετε περισσότερα από 4 ψηφία",
  "pleaseValidEmail": "Εισαγάγετε τη σωστή διεύθυνση email",
  "pleaseValidPhone": "Εισαγάγετε τον σωστό αριθμό τηλεφώνου",
  "productAvailable": "Αυτό το προϊόν έχει καταργηθεί",
  "validatorMaxNumber": "Το ποσό υπερβαίνει το όριο",
  "validatorRequire": "Τα υποχρεωτικά στοιχεία δεν μπορούν να είναι μηδενικά",
  "validatorPhone": "Εισαγάγετε τον σωστό αριθμό τηλεφώνου",
  "validatorEmail": "Εισαγάγετε τη σωστή μορφή email",
  "validatorPassword": "Ο κωδικός πρόσβασης αποτελείται από 6-12 ψηφία ή γράμματα(περιέχει ειδικούς χαρακτήρες)",
  "validatorSixNumber": "Εισαγάγετε 6 καθαρά ψηφία",
  "validatorFourMoreNumber": "Εισαγάγετε έναν συνδυασμό 4-32 ψηφίων ή γραμμάτων",
  "validatorIpRule": "Λανθασμένη μορφή IP",
  "validatorChineseAndEnglish": "Μόνο κινέζικα και αγγλικά, εισαγάγετε εύρος: 8-64 χαρακτήρες",
  "collectionSuccess": "Προσθήκη στα αγαπημένα με επιτυχία",
  "followedSuccess": "Η παρακολούθηση πέτυχε",
  "cancelSuccess": "Η ακύρωση πέτυχε",
  "evaluateOrder": "Κριτική με εικόνες",
  "evaluateOrderPlaceholder": "Παρακαλούμε ελέγξτε τα προϊόντα",
  "operationSuccess": "Η επιχείρηση πέτυχε",
  "confirmReceiveGoods": "Επιβεβαιώστε την παραλαβή του προϊόντος ή όχι",
  "evaluateOrderSuccess": "Η κριτική πέτυχε",
  "yesterday": "Εχθές",
  "notLogin": "Δεν έχετε συνδεθεί ακόμα.",
  "delAllHistoryRecord": "Είστε βέβαιοι ότι θέλετε να διαγράψετε όλο το αρχείο ιστορικού;",
  "or": "Ή",
  "tipsRemindsText": "Ο έμπορος θα λάβει μια υπενθύμιση μετά την υπενθύμιση της αποστολής",
  "tipsRemindsCount": "Μπορεί να υπενθυμιστεί μόνο μία φορά.",
  "tipsRemindsMerchant": "Υπενθύμιση στους εμπόρους",
  "tipsRemindsSuccess": "Η υπενθύμιση πέτυχε",
  "noCartTips": "Η τσάντα για τα ψώνια σας είναι άδεια. Ξεκινήστε τις αγορές.",
  "defaultRate": "Το σύστημα προεπιλογή για ευνοϊκές κριτικές",
  "prevPage": "Προηγούμενη σελίδα",
  "nextPage": "Επόμενη σελίδα",
  "returnApply": "Αίτηση επιστροφής χρημάτων",
  "returnReason": "Λόγος επιστροφής χρημάτων",
  "returnAmount": "Ποσό επιστροφής",
  "returnRemark": "Οδηγίες επιστροφής",
  order: {
    confirm: "Επιβεβαιώστε την παραλαβή",
    payment: "Πλήρωσε τώρα",
    remind: "Υπενθύμιση για αποστολή",
    return: "Αίτημα για επιστροφή χρημάτων προϊόντος",
    evaluate: "Επανεξέταση τώρα",
    logistics: "Προβολή logistics",
    noRefund: "Χωρίς επιστροφή χρημάτων",
    refunding: "Επιστροφή χρημάτων σε εξέλιξη",
    refundSuccess: "Επιτυχής επιστροφή χρημάτων",
    refundFail: "Η επιστροφή χρημάτων απέτυχε",
        expressCompany: 'Μεταφορική',
        trackingNo: 'Αριθμός παρακολούθησης',
        noOrderShipping: 'Δεν υπάρχουν στοιχεία αποστολής',
        noTransitSteps: 'Δεν υπάρχουν ενημερώσεις παρακολούθησης',
        logisticsLoadFail: 'Αποτυχία φόρτωσης logistics. Δοκιμάστε ξανά αργότερα.'
  },
  "remindTitle": "Υπενθύμιση για αποστολή",
  "remindContent": "Αφού υπενθυμιστεί η αποστολή, ο έμπορος θα λάβει την υπενθύμιση. Μπορεί να υπενθυμιστεί μόνο μία φορά.",
  "remindSuccess": "Η υπενθύμιση πέτυχε",
  "remindRepeat": "Αυτή η παραγγελία έχει υπενθυμιστεί.",
  "noComments": "Καμία κριτική προς το παρόν",
  "storeSeach": "Αναζητήστε προϊόν σε αυτό το κατάστημα",
  "storeSeachTips1": "Βρέθηκε για εσάς",
  "storeSeachTips2": "Βρέθηκαν σχετικά καταστήματα",
  "storeSeachTips3": "Σπίτι",
  "creditTit": "Πιστωτικές υπηρεσίες",
  "getCoupons": "Λάβετε περισσότερα κουπόνια",
  "yourEmail": "η ηλεκτρονική σου διεύθυνση",
  "subscription": "Συνδρομές",
  "paymethods": "Μέθοδος πληρωμής",
  "footdec": "Οι παγκόσμιοι χρήστες του {name} προέρχονται από {num} χώρες σε όλο τον κόσμο και χρησιμοποιούν {coin} για διακανονισμό. Το {coin} είναι μια συναλλαγή χωρίς σύνορα που επιτρέπει άμεσες συναλλαγές χαμηλού κόστους σε όλο τον κόσμο χωρίς αναμονή και διεθνείς χρεώσεις.",
  "custService": "Εξυπηρέτηση πελατών",
  "helpLine": "Ηλεκτρονική εξυπηρέτηση πελατών",
  "contactUs": "Επικοινωνήστε μαζί μας",
  "partner": "Συνεταιριστικοί προμηθευτές",
  "buyRules": "Κανόνες αγοραστή",
  "客户端下载":"Λήψεις πελάτη",
  "提现方式": "Μέθοδος απόσυρσης",
  "sellerRules": "Πολιτική πωλητή",
  "returnsAndEx": "Επιστροφές και ανταλλαγή",
  "servicePolicy": "Πολιτική εξυπηρέτησης",
  "returnPolicy": "ΠΟΛΙΤΙΚΗ ΕΠΙΣΤΡΟΦΗΣ ΠΡΟΪΟΝΤΩΝ",
  "user_Center": "Κέντρο χρηστών",
  "userReg": "Εγγραφή χρήστη",
  "orderTrack": "Ερώτημα παραγγελίας",
  "purchageHistory": "Ιστορικό αγορών",
  "myPurse": "Το πορτοφόλι μου",
  "aboutUs": "Σχετικά με εμάς",
  "Recruitment": "Περιμένετε ταλαντούχους ανθρώπους",
  "news": "Πληροφορίες ειδήσεων",
  "stateMent": "Δήλωση σύγχρονης δουλείας",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "οκχ",
  "metaMask": "MetaMask",
  "homeBannertips1": "Γίνε έμπορος",
  "homeBannertips2": "Συνολική προμήθεια",
  "homeBannertips3": "Μέγιστη.",
  "homeBannerbtn": "Πάρε μέρος τώρα",
  "homeDownloadtips1": "Διασυνοριακό εμπορικό κέντρο χονδρικής",
  "homeDownloadtips2": "Ειδική προσφορά μάρκας",
  "homeDownloadtips3": "Έκπτωση χωρίς στάση",
  "homeDownloadtips4": "Λήψη Android",
  "homeDownloadtips5": "Λήψη της Apple",
  "homeDownloadtips6": "Σάρωση κωδικού QR για λήψη της APP",
  "homeIconTips1": "100% Γνήσιο",
  "homeIconTips2": "7 ημέρες επιστροφή",
  "homeIconTips3": "Έκπτωση φορτίου",
  "homeIconTips4": "ασφαλής πληρωμή",
  "headerSearchTips": "Εισαγάγετε λέξη-κλειδί για αναζήτηση",
  "collAccount": "Τρόπος δανείου",
  "mine": "Δικος μου.",
  "creditText1": "Τα δάνεια εκκίνησης λύνουν το πρόβλημα του δανεισμού χρημάτων",
  "creditText2": "Παρέχετε υπηρεσίες δανείου εκκίνησης και κύκλου εργασιών κεφαλαίου",
  "creditWorry": "Δάνειο χωρίς άγχος",
  "creditQuota": "Ευέλικτο όριο",
  "creditQuotaINFO": "100.000 έως 30.000.000 με ευέλικτο όριο και χωρίς περιορισμούς, με μέγιστη διάρκεια δανείου τον ένα χρόνο.",
  "quickLoan": "Γρήγορο δάνειο",
  "creditReview": "Περάστε τον έλεγχο σε μία ώρα το νωρίτερο, εάν ο έλεγχος περάσει, το δάνειο θα αποδεσμευτεί αμέσως.",
  "safe": "Ασφαλές και χωρίς ανησυχίες",
  "safeInfo": "Χωρίς υποθήκη, χωρίς κατάθεση, χωρίς επιστροφή, γιατί αυτό είναι στην πραγματικότητα μια ιδιωτική υπόθεση.",
  "about": "Σχετικά με εμάς",
  "aboutText1": "Δεσμευόμαστε για τις χρηματοοικονομικές υπηρεσίες δανείου, με βάση την επιχειρηματική φιλοσοφία «πρώτα ο πελάτης», έχοντας ως αποστολή την επίλυση του προβλήματος του κύκλου εργασιών των πελατών. Από την ίδρυσή της, η εταιρεία έχει βοηθήσει πολλούς πελάτες να λύσουν το πρόβλημα του κύκλου εργασιών κεφαλαίου.",
  "aboutText2": "Όριο: 100.000-30.000.000, ευέλικτη μέθοδος αποπληρωμής με χαμηλό επιτόκιο, χωρίς προκαταβολή, διαδικτυακό δάνειο, χωρίς τηλεφώνημα για επαλήθευση, εμπιστευτικές πληροφορίες και αυθημερόν δανεισμό.",
  "contactUs1": "Εάν δεν θέλετε να δανειστείτε χρήματα από τους συναδέλφους σας, επικοινωνήστε μαζί μας.",
  "committed": "Δεσμευμένος για υπηρεσίες δανείου επιχειρηματιών",
  "financial": "Αντιμετωπίστε τις οικονομικές σας ανησυχίες",
  "partnersTit": "Συνεργάτης-Διαδικτυακή πλατφόρμα δανεισμού",
  "application": "Αίτηση για δάνειο",
  "applicant": "Αιτών",
  "actualName": "Το πραγματικό του όνομα",
  "yourName": "Εισαγάγετε το όνομα",
  "term": "Διάρκεια δανείου",
  "applicationAmount": "Ποσό που ζητήθηκε",
  "rates": "Επιτόκιο δανείου",
  "loanMethod": "Τρόπος δανείου",
  "accountB": "Υπόλοιπο λογαριασμού",
  "countryOf": "Ιθαγένεια",
  "myloan": "Το δάνειό μου",
  "applyLoan": "Κάντε αίτηση για δάνειο",
  "loaned": "Δανεισμένος",
  "interest": "Συλλογισμένοι τόκοι",
  "esRepayment": "Εκτιμώμενη αποπληρωμή",
  "loanHistory": "Ρεκόρ δανείου",
  "applicantDate": "Ημερομηνία αίτησης",
  "repayment": "Ανταπόδοση",
  "cycle": "Κύκλος αποπληρωμής",
  "fixedRate": "Σταθερό επιτόκιο",
  "successLoan": "Το δάνειο πέτυχε",
  "Reapply": "Κάντε ξανά αίτηση",
  "borrow": "Το δάνειο απέτυχε",
  "applicantIn": "Εφαρμογή σε εξέλιξη",
  "repaid": "Ανταπόδοση",
  "overdue": "Εκπρόθεσμος",
  "estirepay": "Εκτιμώμενη αποπληρωμή",
  "loanDays": "Αριθμός ημερών δανεισμού",
  "reAmount": "Ποσό αποπληρωμής",
  "repay": "Τρόπος αποπληρωμής",
  "entRepay": "Επιβεβαιώστε την εξόφληση",
  "foryourmoney": "Εάν βρίσκεστε σε έλλειψη ταμείου, δεν βρίσκετε πού να δανειστείτε χρήματα ή ντρέπεστε να δανειστείτε χρήματα από τους φίλους σας, μπορείτε να επικοινωνήσετε μαζί μας. Έχουμε όλη τη διαδικασία επαγγελματικής εξυπηρέτησης για να απαντήσουμε στις αμφιβολίες σας ανά πάσα στιγμή. Στόχος μας είναι να κάνουμε κάθε δάνειο διαφανές, ώστε οι πελάτες να μπορούν να το χρησιμοποιούν γρήγορα και με σιγουριά.",
  "onlineApplin": "Υποβάλλετε αίτηση ηλεκτρονικά",
  "businessloan": "Αίτηση για δάνειο εκκίνησης",
  "selectCountry": "Επιλέξτε μια εθνικότητα",
  "selectPeriod": "Επιλέξτε μια περίοδο",
  "passPortImg": "Αριθμός Ταυτότητας/Αριθμός Διαβατηρίου.",
  "uploadId": "Μεταφόρτωση φωτογραφίας/διαβατηρίου πιστοποιητικού",
  "readAndAgree": "Έχω διαβάσει και συμφωνώ",
  "loanAgree": "Δανειακή σύμβαση",
  "submitApplica": "Υποβολή αίτησης",
  "photoExample": "Παράδειγμα λήψης φωτογραφιών",
  "discounted": "Προϊόντα με έκπτωση",
  "days": "ημέρα",
  "privacyPolicy": "Πολιτική απορρήτου",
  "delivery": "Παράδοση και παραλαβή",
  "checkAgreement": "Παρακαλώ σημειώστε τη συμφωνία!",
  "businessPhone": "Τηλέφωνο εργασίας",
  "businessEmail": "Εταιρικό E-mail",
  "提交失败": "Η υποβολή απέτυχε",
  "充值金额不能小于1": "Το ποσό επαναφόρτισης δεν μπορεί να είναι μικρότερο από 1 (συμπεριλαμβανομένων δύο δεκαδικών ψηφίων)",
  "请切换其他语言后查看": "Μεταβείτε σε άλλη γλώσσα για προβολή",
  "我的购物车": "Το καλάθι αγορών μου",
  "推荐商品": "Προτεινόμενα προϊόντα",
  "猜你喜欢": "Μαντέψτε ότι σας αρέσει.",
  "暂无店铺": "Δεν βρέθηκε κατάστημα",
  "添加失败": "Αποτυχία υποβολής. Παρακαλώ δοκιμάστε ξανά αργότερα",
  "提交订单": "Υποβολή παραγγελίας",
  "请选择": "Παρακαλώ επιλέξτε",
  "提款地址绑定": "Διεύθυνση ανάληψης",
  "绑定成功": "Επιτυχής σύνδεση",
  "企业电话": "Τηλέφωνο εργασίας",
  "职业机会": "ευκαιρίες καριέρας",
  "仅能绑定一个收款地址!": "Μόνο μια διεύθυνση πληρωμής μπορεί να συνδεθεί!",
  "最多包含10位小数": "Μέχρι 10 δεκαδικά ψηφία",
  footTipTikTok:'BizSpring Mall ©️2024 Πνευματικά δικαιώματα',
  TikTokFoot:"Το BizSpring Mall είναι μια παγκόσμια πλατφόρμα κοινωνικής δικτύωσης μικρού μήκους βίντεο, η BizSpring και η μεγαλύτερη εταιρεία χονδρικής εμπορίας της Ασίας Alibaba, που ιδρύθηκε σε συνεργασία. Είναι μια παγκόσμια πλατφόρμα ηλεκτρονικού εμπορίου και διαθέτει τρεις αυτολειτουργούμενες έξυπνες αποθήκες στον κόσμο, που βρίσκονται στο Τορόντο του Καναδά, στο Λος Άντζελες και στην Τσίμπα της Ιαπωνίας. Τα προϊόντα που πωλούνται στην εφαρμογή περιλαμβάνουν δημοφιλή προϊόντα από την Ιαπωνία, τη Νότια Κορέα, την Κίνα και άλλες ασιατικές χώρες. Προς το παρόν, ο συνολικός αριθμός έχει ξεπεράσει τις 50.000 και συνεχίζει να αυξάνεται ραγδαία."
,
  "getCouponSuccess": "Εξαργυρώθηκε επιτυχώς",
  "liveRooms": "Αίθουσες Ζωντανής Μετάδοσης",
  "liveStreaming": "Ζωντανά",
  "notStarted": "Δεν Ξεκίνησε",
  "finished": "Ολοκληρώθηκε",
  "myPoints": "Οι Πόντοι Μου",
  "searchGoods": "Αναζήτηση Προϊόντων",
  "points": "Πόντοι",
  "point": "Πόντοι",
  "stock": "Απόθεμα",
  "spec": "Προδιαγραφή",
  "exchangeNow": "Εξαργύρωση Τώρα",
  "currentPoint": "Οι Πόντοι Μου",
  "pointNotEnough": "Ανεπαρκείς πόντοι"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "希腊语(el)",
    "addImageHint": "(Προσθέστε εικόνες)",
    "deleteNode": "Διαγραφή",
    "topPos": "Κορυφή {n}",
    "col": "Στήλη {n}",
    "pos": "Θέση {n}",
    "decoType_container": "Κοντέινερ",
    "decoType_title": "Κείμενο τίτλου",
    "decoType_richText": "Εμπλουτισμένο κείμενο",
    "decoType_notice": "Ανακοίνωση",
    "decoType_blank": "Διάστημα",
    "decoType_banner": "Καρουζέλ",
    "decoType_imageSingle": "Μία εικόνα",
    "decoType_imageMulti": "Πολλαπλές εικόνες",
    "decoType_video": "Βίντεο",
    "decoType_goodsRecommend": "Προτεινόμενα προϊόντα",
    "decoType_goodsSelection": "Επιλογή προϊόντων",
    "decoType_seckill": "Flash πώληση",
    "decoType_groupBuy": "Ομαδική αγορά",
    "decoType_coupon": "Κουπόνι",
    "decoType_searchNav": "Πλοήγηση αναζήτησης",
    "decoType_search": "Πλαίσιο αναζήτησης",
    "decoType_searchBox": "Πλαίσιο αναζήτησης",
    "decoType_categoryNav": "Πλοήγηση κατηγοριών",
    "decoType_goodsCategory": "Κατηγορία προϊόντων",
    "decoType_navIconRow": "Εικονίδια πλοήγησης",
    "decoType_imageScroll": "Κύλιση εικόνων",
    "decoType_pageBanner": "Banner σελίδας",
    "decoType_tabs": "Καρτέλες",
    "decoType_brand": "Μάρκα",
    "decoType_storeRecommend": "Προτεινόμενα καταστήματα",
    "decoType_hotSelection": "Δημοφιλής επιλογή",
    "decoType_footerLinkGroup": "Σύνδεσμοι υποσέλιδου",
    "decoType_partnerLogoRow": "Συνεργάτες",
    "decoType_icpInfo": "Πληροφορίες ICP",
    "decoType_topNavMenu": "Άνω πλοήγηση",
    "decoType_logoBlock": "Λογότυπο",
    "decoType_langSwitcher": "Γλώσσα",
    "decoType_currencySwitcher": "Νόμισμα",
    "decoType_loginBlock": "Σύνδεση",
    "decoType_cartIcon": "Καλάθι",
    "decoType_messageIcon": "Μηνύματα",
    "seckillPrice": "Τιμή flash",
    "seckillTag": "Flash πώληση",
    "seckillCountdown": "Λήγει σε",
    "seckillNotStarted": "Σύντομα",
    "seckillRushing": "Σε εξέλιξη",
    "seckillWillStart": "Σύντομα",
    "seckillBuy": "Αγορά τώρα (flash)",
    "groupPrice": "Ομαδική τιμή",
    "groupRequiredNum": "άτομα για ομάδα",
    "noGroupBuy": "Αγορά μόνος",
    "groupRule1": "1. Επιλέξτε προϊόν",
    "groupRule2": "2. Ξεκινήστε ομάδα",
    "groupRule3": "3. Ολοκλήρωση ομάδας → αποστολή",
    "marketingMoneyOff": "Έκπτωση",
    "marketingFreeShipping": "Δωρεάν αποστολή",
    "marketingGift": "Δώρο",
    "marketingCoupon": "Κουπόνι",
    "marketingGroup": "Ομαδική αγορά",
    "marketingSeckill": "Flash πώληση",
    "marketingExpired": "Η προσφορά έληξε",
    "marketingNotActive": "Η προσφορά δεν είναι ενεργή",
    "alreadyGotCoupon": "Ελήφθη",
    "couponReceived": "Ελήφθη",
    "hotSearch": "Δημοφιλείς αναζητήσεις:"
}